/**
 * InfoAlerts - Information and Warning Alerts for Keyword Byte Counter
 */

import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle, AlertDescription } from '@/components/v2/ui';

interface InfoAlertsProps {
  byteCount: number;
}

export function InfoAlerts({ byteCount }: InfoAlertsProps) {
  const { t } = useTranslation();
  return (
    <>
      {/* Warning or Info Alert */}
      <Alert variant={byteCount > 250 ? 'error' : 'info'}>
        <AlertTitle>
          {byteCount > 250 ? `⚠️ ${t('editor.byteLimit')}` : `ℹ️ ${t('editor.byteLimitHint')}`}
        </AlertTitle>
        <AlertDescription className="text-xs leading-relaxed">
          {byteCount > 250 ? (
            <>
              <strong>{t('editor.byteLimitWarning')}</strong>
              <br />
              {t('keywordByteCounter.reduceWarning', { count: byteCount - 250 })}
            </>
          ) : (
            <>
              <span dangerouslySetInnerHTML={{ __html: t('keywordByteCounter.byteLimitInfo') }} />
              {' '}{t('editor.umlautsNote')}
            </>
          )}
        </AlertDescription>
      </Alert>

      {/* Best Practices */}
      <Alert variant="info">
        <AlertTitle>{`💡 ${t('keywordByteCounter.bestPracticesTitle')}`}</AlertTitle>
        <AlertDescription className="text-xs leading-relaxed space-y-1">
          <p>{`✓ ${t('keywordByteCounter.tipSingleField')}`}</p>
          <p>{`✓ ${t('keywordByteCounter.tipNoDuplicates')}`}</p>
          <p>{`✓ ${t('keywordByteCounter.tipNoBrands')}`}</p>
          <p>{`✓ ${t('keywordByteCounter.tipSpaceSeparator')}`}</p>
        </AlertDescription>
      </Alert>
    </>
  );
}
